<template>
  <b-container
    fluid
    class="default-engineering-modules-header"
  >
    <b-row cols="12">
      <b-col
        v-if="imageUrl"
        class="default-engineering-modules-header__image-wrapper"
        md="auto"
        xs="12"
      >
        <b-img
          class="default-engineering-modules-header__image"
          center
          :src="imageUrl"/>
      </b-col>
      <b-col xs="12">
        <b-row>
          <b-col
            v-if="shouldShowTitle"
            class="default-engineering-modules-header__column-title"
            lg="8"
            md="8"
            sm="12"
          >
            <h1>
              {{ title }}
            </h1>
            <h3 v-if="shouldShowSubtitle">
              {{ subtitle }}
            </h3>
          </b-col>
          <b-col
            lg="4"
            md="4"
            sm="12"
          >
            <icons-header
              :notifications="notifications"
              :showUpdateIcon="showUpdateIcon"
              :showWifiIcon="showWifiIcon"
              :showInfoIcon="showInfoIcon"
              :showTreeviewIcon="showTreeviewIcon"
              :showPrintIcon="showPrintIcon"
            />
          </b-col>
        </b-row>
        <div
          class="default-engineering-modules-header__row-asset-data"
        >
          <div
            class="default-engineering-modules-header__column-asset-data-header"
          >
            <default-data-header
              :items="items"
            />
          </div>
          <div
            class="default-engineering-modules-header__column-last-update"
          >
            <span v-if="!!lastUpdate">
              {{ $t('asset-list.last-update') }}: {{
                this.lastUpdate | dateTimeFilter({ format: formats.DATETIME_SHORT_WITH_SECONDS})
              }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DefaultDataHeader from '@/components/header/DefaultDataHeader';
import IconsHeader from '@/components/header/IconsHeader';
import IconsHeaderMixin from '@/components/header/mixin/iconsHeaderMixin';
import AssetDataHeaderMixin from '@/components/header/mixin/assetDataHeaderMixin';
import EngineeringModulesHeaderMixin from '@/components/header/mixin/engineeringModulesHeaderMixin';
import { formats } from '@/constants/localizer';

export default {
  props: {
    imageUrl: {
      type: String,
      default: null,
    },
    lastUpdate: {
      type: String,
      default: '',
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DefaultDataHeader,
    IconsHeader,
  },
  mixins: [
    AssetDataHeaderMixin,
    EngineeringModulesHeaderMixin,
    IconsHeaderMixin,
  ],
  data: () => ({ formats }),
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"
  $image-size: 80px

  .default-engineering-modules-header
    position: relative

    &::after
      content: ''
      border-bottom: 2px solid var(--color-border-gray)
      display: block
      width: 100%
      z-index: 1

    &__row-asset-data
      margin-top: 20px
      display: flex
      justify-content: space-between
      +media-max-sm()
        flex-direction: column

    &__column-title
      display: flex
      align-items: baseline
      & h1
        font-size: 1.45rem
      & h3
        margin-left: 1rem
      +media-sm()
        justify-content: center
      +media-xs()
        justify-content: center

    &__image-wrapper
      margin-bottom: 1rem
      display: flex
      align-content: center
      padding-left: 30px
    &__image
      width: $image-size
      height: $image-size
    &__column-icons
      display: flex
      justify-content: flex-end
      & button
        border: none
        background-color: transparent
      +media-sm()
        justify-content: center
        margin-top: 1rem
      +media-xs()
        justify-content: center
        margin-top: 1rem

    &__column-asset-data-header
      display: flex
      +media-sm()
        justify-content: center
      +media-xs()
        justify-content: center

    &__column-last-update
      display: flex
      justify-content: flex-end
      align-items: center
      margin-bottom: 2rem
      & span
        font-size: 11px
        color: var(--color-border-gray)
      +media-sm()
        justify-content: center
      +media-xs()
        justify-content: center
</style>
